import gql from 'graphql-tag';

export default gql(/* GraphQL */ `
  mutation leaveReservableWaitlist($enrollmentId: UUID!) {
    leaveReservableWaitlist(enrollmentId: $enrollmentId) {
      startDate
      endDate
    }
  }
`);
